import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ContentsItem } from '../../../modules/editor/types';
import { RootState } from '../../../modules';
import VideoToolbar from '../Toolbar/VideoToolbar';
import { editContent } from '../../../modules/editor';
import classNames from 'classnames';
import Spinner from '../../../components/Spinner';
import useIsImageUploading from '../../../hooks/useIsImageUploading';

type Props = {
	contentItem: ContentsItem
};

function Video({ contentItem }: Props) {
	const dispatch = useDispatch();
	const [isDummy, setIsDummy] = useState(false);
	const [showToolbar, setShowToolbar] = useState(false);
	const [linkModalOpen, setLinkModalOpen] = useState(false);	
	const contentId = useMemo(() => contentItem.id, [contentItem.id]);

	const { selectedContentId, prevSelectedContentId } = useSelector(({ editor: { selectedContentId, prevSelectedContentId }}: RootState) => ({ selectedContentId, prevSelectedContentId }));
	const contentBeforeSave = useRef(contentItem.content.content[0]);

	useEffect(() => {
		if (selectedContentId !== contentItem.id) {
			unselectContent();
		}
		if (prevSelectedContentId === contentId) {
			const needsToSave = Object.keys(contentBeforeSave.current).some((key) => {
				const before = contentBeforeSave.current[key];
				const after = contentItem.content.content[0][key];
				return before !== after;
			});
			if (needsToSave) {
				dispatch(editContent({ target: `${contentId}/content/0/imageAlt`, data: contentItem.content.content[0].imageAlt, mode: 'force' }));
			}
			contentBeforeSave.current = contentItem.content.content[0];
		}
	}, [selectedContentId]);
	
	useEffect(() => {
		setIsDummy(contentItem?.content.content[0]?.imagePath?.includes('dummy') || false);
	}, [contentItem])

	const startEditing = () => {
		setShowToolbar(true);
	}

	const unselectContent = () => {
		setShowToolbar(false);
		setLinkModalOpen(false)
	}

	const openLinkModal = () => {		
		startEditing();
		setTimeout(() => {			
			setLinkModalOpen(true);
		}, 10);
	}
	const { imageRef, isImageUploading }= useIsImageUploading(`${contentItem.id}/content/0/imageLink`);

	return (
		<div className={classNames('video-edit', showToolbar && 'active')}>
			<div className="video-edit-content">
				<div className="img-wrapper">
					<img ref={imageRef} src={contentItem?.content.content[0].imagePath} alt={contentItem?.content.content[0].imageAlt} />
					{isImageUploading && <div className={classNames('img-spinner', isImageUploading && 'active')}>
						<Spinner size={18} />
					</div>}
				</div>
				{
					contentItem?.content?.content[0]?.imagePath?.includes('dummy_video') && (
						<p className="dummy-text">링크 버튼을 눌러 유튜브 동영상 주소를 입력하세요</p>
					)					
				}
			</div>
			{
				showToolbar ? (
					<VideoToolbar
						innerContent={contentItem.content.content[0]}
						style={contentItem.content.style[0].partition}
						contentId={contentItem.id}
						contentIndex={0}
						isLinkModalOpen={linkModalOpen}
					/>
				) : (
					<div className="cover" onClick={isDummy ? openLinkModal : startEditing} />
				)
			}
		</div>
	)
}

export default Video;